var _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "233.656 238.043 50 50",
    enableBackground: "new 233.656 238.043 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#01C28D",
    d: "M248.14,254.87l7.478-5.432c0.84-0.613,1.859-0.928,2.899-0.896c2.6,0.064,4.872,1.769,5.663,4.246 c0.434,1.36,0.83,2.28,1.189,2.758c2.201,2.938,5.658,4.664,9.328,4.662v4.666c-4.879,0.006-9.503-2.176-12.604-5.943l-1.626,9.229 l4.809,4.037l5.187,14.25l-4.387,1.596l-4.76-13.074l-7.909-6.639c-1.321-1.066-1.959-2.77-1.663-4.441l1.188-6.732l-1.58,1.148 l-4.962,6.832l-3.775-2.744l5.485-7.55L248.14,254.87z M261.865,247.376c-2.577,0-4.666-2.089-4.666-4.666s2.089-4.667,4.666-4.667 s4.666,2.089,4.666,4.667S264.442,247.376,261.865,247.376z M254.931,278.129l-7.498,8.938l-3.575-2.998l6.944-8.273l1.74-5.088 l4.179,3.5L254.931,278.129z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233.656,
    y: 238.043,
    fill: "none",
    width: 50,
    height: 50
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitness);
export default __webpack_public_path__ + "static/media/Fitness.bc52e02458e6ba60fec3c82f1f4e1cbf.svg";
export { ForwardRef as ReactComponent };